module.exports = __webpack_public_path__ + "img/laboratorio3_4-3_2048.aca9c394.webp";